export default __webpack_public_path__ + "static/media/logo.a3a0eeab.svg";